import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { refreshAccessToken } from './tokenRefreshService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

// Crea istanza axios con configurazione base
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000 // 30 secondi
  // NON impostiamo Content-Type di default per permettere ad axios
  // di gestirlo automaticamente (es: multipart/form-data per FormData)
});

// Fix B9: la logica refresh vera (chiamata server + singleton lock) e
// ora in `tokenRefreshService.ts`, condivisa con `authLink.ts` (Apollo).
// Niente piu `isRefreshing` ne `failedQueue` locali: ogni richiesta axios
// in 401 attende il singleton promise; chiamate concorrenti vedono lo
// stesso promise e procedono in parallelo quando completa.

// Interceptor per aggiungere token a ogni richiesta
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor per gestire errori di autenticazione con refresh automatico.
// La deduplicazione (chiamate concorrenti che attendono lo stesso refresh)
// e gestita dal singleton promise dentro `refreshAccessToken()`: se un
// refresh e gia in volo, questa await ricevera lo stesso promise.
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean };

    if (error.response?.status === 401 && !originalRequest._retry) {
      const currentPath = window.location.pathname;

      // Non tentare refresh se siamo su pagine di login
      if (currentPath.includes('/login') || currentPath.includes('/accesso-associati')) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      try {
        const newToken = await refreshAccessToken();

        if (originalRequest.headers) {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
        }

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // Refresh fallito: il service ha gia rimosso i token da localStorage.
        // Qui gestiamo solo il redirect al login admin.
        window.location.href = '/admin/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

